module.exports = __webpack_public_path__ + "media/images/country_flags/ge-f9843d4d2769e1753e87f1afffcec9d3.png";